import { h } from 'preact';
import { Text } from 'preact-i18n';
import StockList from '../stock-list';
import Container from '../container';
import { containerSize } from '@cube/blocks';

export function FundsPanel({ width }) {
	let dollarVolumeColumns = ['symbolWithName', 'price', 'changePrice', 'dollarVolume'];
	let volumeColumns = ['symbolWithName', 'price', 'changePrice', 'changePercent'];

	if (width && width > 500) {
		dollarVolumeColumns.splice(2,0,'changePercent');
		volumeColumns.push('volume');
	}

	return (
		<Container parent>
			<Container title={<Text id="MOST_ACTIVE_FUNDS" />}>
				<StockList
					showHeaders
					query={{
						type: 'FUND',
						list: '+dollarVolume',
						limit: 5
					}}
					columns={dollarVolumeColumns}
					trackingSource="funds-panel/most-active-funds"
				/>
			</Container>
			<Container title={<Text id="FUND_GAINERS" />}>
				<StockList
					showHeaders
					query={{
						type: 'FUND',
						list: '+percentChange',
						limit: 5
					}}
					columns={volumeColumns}
					trackingSource="funds-panel/fund-gainers"
				/>
			</Container>
			<Container title={<Text id="POPULAR_FUNDS" />}>
				<StockList
					showHeaders
					query={{
						type: 'FUND',
						list: '+popularity',
						limit: 5
					}}
					columns={volumeColumns}
					trackingSource="funds-panel/popular-funds"
				/>
			</Container>
			<Container title={<Text id="FUND_LOSERS" />}>
				<StockList
					showHeaders
					query={{
						type: 'FUND',
						list: '-percentChange',
						limit: 5
					}}
					columns={volumeColumns}
					trackingSource="funds-panel/fund-losers"
				/>
			</Container>
		</Container>
	);
}

export default containerSize({ height: false })(FundsPanel);



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/funds-panel/index.js